const config = {
  base_url:
    process.env.NODE_ENV === 'production'
      ? 'https://auth-functions.pinchos.se'
      : 'http://localhost:8080', // run the `auth-functions` repo locally for dev testing
};

export default config;
